import { BsModalRef } from 'ngx-bootstrap/modal';

export const SLIDEOUT_MODAL_ANIMATION_MS = 350;
export const SLIDEOUT_MODAL_CLOSING_CLASS = 'modal-slideout-closing';

export function isSlideoutBackdropClick(event: MouseEvent): boolean {
  const target = event.target as HTMLElement;
  return target.classList.contains('modal') && target.classList.contains('fade');
}

export function animateSlideoutBackdropClose(doc: Document): void {
  doc.querySelector('.modal-backdrop')?.classList.add('modal-backdrop-transition');
}

export function beginSlideoutModalClose(doc: Document): boolean {
  const modalEl = doc.querySelector<HTMLElement>('.modal.fade.show');

  if (!modalEl || modalEl.classList.contains(SLIDEOUT_MODAL_CLOSING_CLASS)) {
    return false;
  }

  modalEl.classList.add(SLIDEOUT_MODAL_CLOSING_CLASS);
  modalEl.classList.remove('show');
  animateSlideoutBackdropClose(doc);

  return true;
}

export function closeSlideoutModal(bsModalRef: BsModalRef, doc: Document): void {
  if (beginSlideoutModalClose(doc)) {
    setTimeout(() => {
      bsModalRef.hide();
    }, SLIDEOUT_MODAL_ANIMATION_MS);

    return;
  }

  bsModalRef.hide();
}
